import { Injectable } from '@angular/core';

import { OddsOperations, emptyOdds } from '@frontend/sports/odds/feature';

import { BaseBetslipGroupPick } from '../../../../../../core/picks/betslip-group-pick';
import { IPrice, PickOddsState } from '../../../../../../core/picks/pick-models';
import { IBetslip } from '../../../../../bet-generation/models';
import { GroupPickComboBetInvalidPrice } from '../../../../errors/general/group-pick-error';
import { ComboBetValidationContext } from '../../../../models/models';
import { IComboBetBetslipValidator } from '../validators';

@Injectable()
export class GroupPickComboBetInvalidPriceValidator implements IComboBetBetslipValidator<GroupPickComboBetInvalidPrice> {
    validate(_: IBetslip, context: ComboBetValidationContext): Iterable<GroupPickComboBetInvalidPrice> {
        const invalidPickIds = context.typeContext.selectedPicks
            .filter((p) => BaseBetslipGroupPick.isPick(p) && p.oddsState === PickOddsState.Open && this.isInvalidPrice(p.actualGroupPrice))
            .map((p) => p.id);

        return invalidPickIds.length ? [new GroupPickComboBetInvalidPrice(invalidPickIds)] : [];
    }

    private isInvalidPrice(price: IPrice | undefined): boolean {
        return OddsOperations.equal(price?.nativeOdds ?? emptyOdds, emptyOdds);
    }
}
